import { render, staticRenderFns } from "./AdminRevenueChart.vue?vue&type=template&id=09955800&scoped=true&"
import script from "./AdminRevenueChart.vue?vue&type=script&lang=js&"
export * from "./AdminRevenueChart.vue?vue&type=script&lang=js&"
import style0 from "./AdminRevenueChart.vue?vue&type=style&index=0&id=09955800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09955800",
  null
  
)

export default component.exports